import { createContext } from 'react';

const SelectedDateContext = createContext<{ selectedDateRange: any; setSelectedDateRange: any }>({
  selectedDateRange: null,
  setSelectedDateRange: () => {}
});

export default SelectedDateContext;
